import type { AgentListPostsParams } from '../api'
import postService from './agent-post.service'
import { EAgentPostQueryKey } from './agent-post.types'

export const agentListPostsOptions = (
  params: AgentListPostsParams,
  enabled: boolean,
) => {
  return {
    queryKey: [EAgentPostQueryKey.AGENT_LIST_POSTS, params],
    queryFn: () => postService.agentListPosts(params),
    enabled: enabled,
  }
}
